import { Container, Button, Card, Image } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { MdWhatsapp } from "react-icons/md";
import "./styles.scss";

import { getAllPartiners } from "../../services/api";
import Brand from "../../assets/img/FOTO JERSU ~1080 2.png";

export default function Grupos() {
    const [partners, setPartners] = useState([]);
    const [countdown, setCountdown] = useState(null);

    useEffect(() => {
        getAllPartiners().then(setPartners);

        const targetDate = new Date("2025-11-28T00:00:00").getTime();

        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                setCountdown("🎉 É HOJE! A Black Friday chegou 🔥");
                clearInterval(timer);
            } else {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                const format = (n) => n.toString().padStart(2, "0");

                setCountdown(
                    `⏰ Virada da Black Friday: ${days} dias ${format(hours)}:${format(
                        minutes
                    )}:${format(seconds)}`
                );
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <Helmet title="Grupos de Ofertas - Black Friday" />
            <Container className="text-center my-5 grupos-wrapper pt-5 mt-5">
                <Image
                    src={Brand}
                    width={120}
                    alt="Foto Jersu"
                    className="mt-5 mb-4"
                    roundedCircle
                />

                <h2 className="fw-bold black-friday-countdown">
                    {countdown || "..."}
                </h2>

                <p className="text-muted">
                    Estamos a mais de 5 anos ajudando milhares de pessoas a economizar!
                </p>

                <div className="d-flex flex-column align-items-center gap-3 mt-4">
                    <Card className="grupo-card whatsapp">
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3">
                                <MdWhatsapp size={30} color="#25D366" />
                                <div className="text-start">
                                    <small className="text-muted">Entre no grupo de WhatsApp</small>
                                    <br />
                                    <strong>150.000 membros</strong>
                                </div>
                            </div>
                            <Button
                                variant="link"
                                href="https://sndflw.com/i/facebookjersutrafego"
                                target="_blank"
                                className="external-link"
                            >
                                🔗
                            </Button>
                        </Card.Body>
                    </Card>
                </div>

                {partners.length > 0 && (
                    <>
                        <hr className="my-5" />
                        <h6 className="text-muted">Conexões diretas com</h6>
                        <div className="store-logos-container d-flex justify-content-center flex-wrap gap-3 mt-3">
                            {partners.map((partner, index) => (
                                <Link
                                    key={index}
                                    to={`/loja/${partner.slug}`}
                                    className="store-logo-link"
                                >
                                    <Image
                                        src={partner.image_url}
                                        alt={partner.name}
                                        className="store-logo"
                                        width={40}
                                        height={40}
                                        roundedCircle
                                    />
                                </Link>
                            ))}
                        </div>
                    </>
                )}
            </Container>
        </>
    );
}
